import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const AttributesSettings = () => {
  return (
    <SettingsCard title="Atributos Personalizados">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default AttributesSettings;